import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefresh = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "-1 -1 19 18",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M7.124 1.508a6.754 6.754 0 1 1-2.896 11.263.25.25 0 0 1 .353-.353 6.254 6.254 0 1 0-1.79-3.71.25.25 0 0 1-.497.057 6.754 6.754 0 0 1 4.83-7.257"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M.359 5.544a.25.25 0 0 1 .347.065l1.88 2.748 2.491-2.291a.25.25 0 0 1 .339.368L2.71 8.921a.25.25 0 0 1-.375-.043L.294 5.89a.25.25 0 0 1 .065-.347"
	})]
});
export default SvgRefresh;
